import {
  CREATEORUPDATELOYALTYPOINT_SUCCESS,
  CREATEORUPDATELOYALTYPOINT_FAILED,
  RESET_CREATEORUPDATELOYALTYPOINT,
  LOADING_CREATEORUPDATELOYALTYPOINT,
  NETWORK_ERROR_CREATEORUPDATELOYALTYPOINT,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_CREATEORUPDATELOYALTYPOINT:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case CREATEORUPDATELOYALTYPOINT_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case CREATEORUPDATELOYALTYPOINT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_CREATEORUPDATELOYALTYPOINT:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_CREATEORUPDATELOYALTYPOINT:
      return (state = initialState);
    default:
      return state;
  }
};
